<a
  class="sharry-featured-card"
  [href]="data()?.externalUrl"
  [ngStyle]="{ 'background-image': 'url(' + data()?.image?.url + ')' }"
  (click)="goTo($event)">
  <div class="sharry-featured-card__content">
    <small
      class="sharry-featured-card__content__address medium"
      sharryEllipsisTooltip
      >{{ data()?.shortAddress }}</small
    >
    <div class="sharry-featured-card__content__container">
      @if (logoUrlExists()) {
        <div [avatar]="{ imgValueUrl: data().logo.url, size: 'small', imgSize: '60px', noBorder: true }"></div>
      }
      <p
        class="bold bigger sharry-featured-card__content__title"
        sharryEllipsisTooltip="2">
        {{ data()?.title }}
      </p>
      <div class="sharry-featured-card__content__bottom">
        <button
          class="rounded sharry-medium bordered"
          color="primary"
          mat-flat-button
          [ngStyle]="{ visibility: data().buttonText ? 'visible' : 'hidden' }">
          {{ data().buttonText }}
        </button>
        <div>
          <span sharryEllipsisTooltip>{{ data()?.sharryKind?.name }}</span>
          <small
            class="sharry-featured-card__content__vendor medium"
            sharryEllipsisTooltip
            >{{ data()?.vendor }}</small
          >
        </div>
      </div>
    </div>
  </div>
</a>
